export default __webpack_public_path__ + "static/communities-small-a4f6d2c1837b740926cecbd623e7756a.jpg";